import { render, staticRenderFns } from "./GroupSurveys.vue?vue&type=template&id=c8c25aaa"
import script from "./GroupSurveys.vue?vue&type=script&lang=js"
export * from "./GroupSurveys.vue?vue&type=script&lang=js"
import style0 from "./GroupSurveys.vue?vue&type=style&index=0&id=c8c25aaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports